import { Loadable } from 'utils/components';
import { PUBLIC_PLAYLIST_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: 'PlaylistPublic' */ './components/PlaylistPublicPage'
      )
  })
};
